import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";


import { getMessaging, getToken, isSupported, onMessage} from "firebase/messaging";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseapp = initializeApp({
  apiKey: "AIzaSyDJ5ZMJ2SkQgrNrlVu19kqJER6387Oydxg",
  authDomain: "tanq-7bdfc.firebaseapp.com",
  projectId: "tanq-7bdfc",
  storageBucket: "tanq-7bdfc.appspot.com",
 
  messagingSenderId: "841024533052",
  appId: "1:841024533052:web:e762b70c50dbe3bcdf0939",
  measurementId: "G-ZH7G7LC2QP"
  });
  
  
 let messaging = null;
 if(isSupported())messaging=getMessaging(firebaseapp);
 
  export const auth = getAuth(firebaseapp);
export const db = getFirestore(firebaseapp);
export const storage = getStorage(firebaseapp);
export const functions = getFunctions(firebaseapp);

export const rtdb = getDatabase(firebaseapp);

/*
export const requestToken = async (setTokenFound) => {
  
  return getToken(messaging, { vapidKey:'BKT7IHkLPWPpRXGxV03z2fYrJOmU4RqE7s_nN3pxbp0FVo3hZgzsGdTSdtqUOx1GW0cfkZSf1dk8WCO-PWOj_tE' })
      .then((currentToken) => {
        if (currentToken) {
          setTokenFound({state:true , token:currentToken,});
          console.log('current token for client: ', currentToken);
          console.log( navigator.clipboard.writeText(currentToken));
          
          // Perform any other neccessary action with the token
        } else {
          setTokenFound({state:false, token:'',});
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
};
*/

export const requestNotificationToken = async () => {
  let result = getToken(messaging, { vapidKey: 'BOOwyNiNdrRcCqqlM3dstzoqFSClB8t-nD8bYVp5_GHP6lnXMgdVRmDaRQL11qnTjbzy0AYz1gqYeD3Z961kB0Y' })
    .then((currentToken) => {
      if (currentToken) {
       //  console.log('current token for client2: ', currentToken);
        return currentToken
        // console.log('token copied to clipboard',  navigator.clipboard.writeText(currentToken));     
        // Perform any other neccessary action with the token
      } else {
        console.log('No registration token available. Request permission to generate one.');
        return null;
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
      return null;
    });
  return result
}



export const onMessageListener = () =>
  new Promise((resolve) => {
    if(messaging)
    onMessage(messaging, (payload) => {
      console.log("payload", payload)
      resolve(payload);
    });
  });